import React, { useEffect, useRef, useState } from 'react'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout'
import { addServerErrors } from '@/components/forms/common/FormBase'
import { useForm } from 'react-hook-form'
import { PageQuery, PageResponse, SearchTable, SearchTableParams, SearchTableRef } from '@/components/search/SearchTable'
import { useModal } from '@/components/modal/Modal'
import { formatDate } from '@/common/time'
import { isDesktopScreen, isLargeScreen, useResponsiveChange } from '@/common/device'
import { BackButton } from '@/components/layout/NavBar'
import { CommonUsernameInput, UsernameInput } from '@/components/forms/common/user/input'
import { Spinner } from '@/components/spinner'
import { CommonUCIDInput, UCIDInput } from '@/components/forms/common/cards/input'

export interface SimpleCard {
  userId: string
  username: string
  ucid: string
  label?: string | null
  createdAt: string
}

export interface CardFormData {
  username: string
  ucid: string
  label?: string | null
}


export const ManagerRemoveCardPopup = ({ services, session, onClose, card }: {
  services: Services,
  session: CurrentSession,
  onClose: () => void,
  card: SimpleCard | undefined
}) => {
  const [error, setError] = useState<boolean>(false)

  useEffect(() => {
    setError(false)
  }, [card?.ucid])

  if (card === undefined) {
    return null
  }

  const remove = (): Promise<void> => {
    return services.session.fetchWithToken(`/api/communal/cards/delete?ucid=${card.ucid}`, {
      method: 'DELETE'
    }).then(async (r) => {
      if (r.status !== 200) {
        setError(true)
      }
      setError(false)
      onClose()
    })
  }
  return <div className='dialog'>
    <div className='dialog-text'>{session.translates.for('elements.table.cards.remove_card_ask').replace('{username}', card.username).replace('{ucid}', card.ucid)}</div>
    <div className='dialog-btns'>
      <div className='dialog-btn' onClick={() => onClose()}>
        <i className='svgfont-no' />
        {session.translates.for('elements.dialog.yesno.no')}
      </div>
      <div className='dialog-btn' onClick={() => remove()}>
        <i className='svgfont-yes' />
        {session.translates.for('elements.dialog.yesno.yes')}
      </div>
      {error ? <div className='dialog-error'>{session.translates.for('elements.table.cards.remove_card_error')}</div> : null}
    </div>
  </div>
}